import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-collapse@1.7.7@rc-collapse/es/index.js
// module id = 223
// module chunks = 0 1